import {SimpleBlueButton} from '../../core/button'
import PieProgressChart from '../pieProgressChart'
import ListView from './listView'
import StatisticsIcon from '../../../assets/images/statistics-icon.svg'
import StatisticsDarkIcon from '../../../assets/images/statistics-icon-dark.svg'
import text from './text.json'
import './index.scss'
import {useSelector} from 'react-redux'

const RulesetListView = ({
    data,
    showFormViewModal,
    rulesetUsageLimit
}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const hasData = data?.length > 0

    return (
        <div className="rulesets-list-container">
            {hasData ? (
                <>
                    <div className='rulesets-usage-details'>
                        <SimpleBlueButton
                            className='add-rulesets-button cancel-button'
                            onClick={showFormViewModal}
                        >
                            {text.create}
                        </SimpleBlueButton>
                        <PieProgressChart
                            value={rulesetUsageLimit.usage}
                            max={rulesetUsageLimit.value}
                            config={{
                                tooltip_text: text.usage_text,
                                label_text: text.usage
                            }}
                        />
                    </div>
                    <ListView
                        data={data}
                        isDarkMode={isDarkMode}
                        showEditModal={showFormViewModal}
                    />
                </>
            ) : (
                <div className="no-rulesets">
                    <img
                        src={isDarkMode ? StatisticsDarkIcon : StatisticsIcon}
                        alt="Statistics"
                        className="no-rulesets-image"
                    />
                    <SimpleBlueButton onClick={showFormViewModal}>
                        {text.create}
                    </SimpleBlueButton>
                </div>
            )}
        </div>
    )
}

export default RulesetListView
